type DateInput = string | number | Date;

const LOCALES: Record<string, string> = {
  pl: "pl-PL",
  en: "en-GB",
};

const localeFor = (language: string): string => LOCALES[language.split("-")[0]] ?? "pl-PL";

export const formatDateTime = (value: DateInput, language: string): string =>
  new Date(value).toLocaleString(localeFor(language), {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

export const formatDate = (value: DateInput, language: string): string =>
  new Date(value).toLocaleDateString(localeFor(language), {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

export const formatTime = (value: DateInput, language: string): string =>
  new Date(value).toLocaleTimeString(localeFor(language), {
    hour: "2-digit",
    minute: "2-digit",
  });

export const daysUntil = (value: DateInput, reference: DateInput = new Date()): number => {
  const dueDate = new Date(value);
  const referenceDate = new Date(reference);

  const dueDay = Date.UTC(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate());
  const referenceDay = Date.UTC(referenceDate.getFullYear(), referenceDate.getMonth(), referenceDate.getDate());

  return Math.round((dueDay - referenceDay) / 86_400_000);
};
